import { render, staticRenderFns } from "./widgetDropdownWithIcon.vue?vue&type=template&id=8a3a5e02&scoped=true"
import script from "./widgetDropdownWithIcon.vue?vue&type=script&lang=js"
export * from "./widgetDropdownWithIcon.vue?vue&type=script&lang=js"
import style0 from "./widgetDropdownWithIcon.vue?vue&type=style&index=0&id=8a3a5e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3a5e02",
  null
  
)

export default component.exports